/* Moustaches & Babines - couche de mouvement */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = 'h1,h2,h3,h4,p,ul,ol,blockquote,figure,picture,img,video,.button,a.button,button.button,.card,.product-card,.resource-card,.media';
  var HERO = /hero|banner|slideshow|slide-show|image-with|media-with|marquee/i;
  var io = null;

  function reveal(t) {
    t.classList.add('mb-in');
    // Un titre « mask » est rogné à 0 px de haut : on observe son parent, puis on le révèle.
    if (t.__mbMask) for (var m = 0; m < t.__mbMask.length; m++) t.__mbMask[m].classList.add('mb-in');
  }

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    return io;
  }

  function taggedAncestor(el, stop) {
    var p = el.parentElement;
    while (p && p !== stop) {
      if (p.hasAttribute && p.hasAttribute('data-mb-reveal')) return true;
      p = p.parentElement;
    }
    return false;
  }

  function decorate(section) {
    if (!section || section.dataset.mbDone) return;
    section.dataset.mbDone = '1';

    var nodes = section.querySelectorAll(SEL);
    var i = 0;
    for (var n = 0; n < nodes.length; n++) {
      var el = nodes[n];
      if (taggedAncestor(el, section)) continue;
      var tag = el.tagName;
      var mask = tag === 'H1' || tag === 'H2';
      el.setAttribute('data-mb-reveal', mask ? 'mask' : 'up');
      el.style.setProperty('--mb-delay', Math.min(i * 65, 320) + 'ms');
      if (mask) {
        var host = el.parentElement || section;
        (host.__mbMask = host.__mbMask || []).push(el);
        observer().observe(host);
      } else {
        observer().observe(el);
      }
      i++;
    }

    if (HERO.test(section.id || '')) {
      var imgs = section.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        var wrap = imgs[k].closest('picture') || imgs[k].parentElement;
        if (!wrap || wrap.hasAttribute('data-mb-zoom')) continue;
        if (imgs[k].clientWidth < 280) continue;
        wrap.setAttribute('data-mb-zoom', '');
        observer().observe(wrap);
      }
    }
  }

  function scan() {
    var main = document.querySelector('#MainContent') || document.body;
    var sections = main.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) decorate(sections[i]);
  }

  // Filet de sécurité : rien ne doit rester caché si l'observateur ne se déclenche pas.
  function failsafe() {
    var els = document.querySelectorAll('[data-mb-reveal]:not(.mb-in)');
    for (var i = 0; i < els.length; i++) {
      var r = (els[i].parentElement || els[i]).getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) els[i].classList.add('mb-in');
    }
  }

  var bar;
  function progress() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mb-progress';
      document.body.appendChild(bar);
    }
    var d = document.documentElement;
    var max = d.scrollHeight - d.clientHeight;
    var top = d.scrollTop || document.body.scrollTop;
    bar.style.transform = 'scaleX(' + (max > 0 ? top / max : 0) + ')';
    if (top > 40) {
      document.body.classList.add('mb-scrolled');
      bar.classList.add('mb-on');
    } else {
      document.body.classList.remove('mb-scrolled');
      bar.classList.remove('mb-on');
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { progress(); failsafe(); ticking = false; });
  }

  function boot() {
    scan();
    progress();
    setTimeout(failsafe, 1500);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) { delete e.target.dataset.mbDone; decorate(e.target); }
  });
  window.addEventListener('pageshow', function () { scan(); progress(); });
})();
